import React from 'react';
import ContactForm from '../ContactFrom'

const ContactSection = () => {

    return(
        <section id="contact" className="tp-contact-pg-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-10 offset-lg-1">
                        <div className="office-info">
                            <div className="row">
                            <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="info-icon">
                                                <i className="fi flaticon-mail"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>E-posta</h2>
                                            <p>info@alza.com.tr</p>
                                        </div>
                                    </div>
                                </div> 
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="info-icon">
                                                <i className="fi flaticon-pin"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>Adres</h2>
                                            <p>Anbar Mah. Demirciler Sit. 20. Cadde No:20, 38070 Melikgazi Kayseri/Türkiye</p>
                                        </div>
                                    </div>
                                </div> 
                                
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="info-icon">
                                                 <i className="fi flaticon-phone-call"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>Telefon</h2>
                                            <p>+90 352 311 4747</p>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                        </div>
                        <div className="working-hours text-center mb-5">
                            <div className="section-title">
                                <h2>Çalışma Saatlerimiz</h2>
                            </div>
                            <div className="hours-list" style={{
                                display: 'inline-block',
                                textAlign: 'left',
                                color: '#999',
                                fontSize: '16px',
                                lineHeight: '2'
                            }}>
                                <div><span style={{minWidth: '120px', display: 'inline-block'}}>Pazartesi</span>: 09:00 - 17:00</div>
                                <div><span style={{minWidth: '120px', display: 'inline-block'}}>Salı</span>: 09:00 - 17:00</div>
                                <div><span style={{minWidth: '120px', display: 'inline-block'}}>Çarşamba</span>: 09:00 - 17:00</div>
                                <div><span style={{minWidth: '120px', display: 'inline-block'}}>Perşembe</span>: 09:00 - 17:00</div>
                                <div><span style={{minWidth: '120px', display: 'inline-block'}}>Cuma</span>: 09:00 - 17:00</div>
                                <div><span style={{minWidth: '120px', display: 'inline-block'}}>Cumartesi</span>: Kapalı</div>
                                <div><span style={{minWidth: '120px', display: 'inline-block'}}>Pazar</span>: Kapalı</div>
                            </div>
                        </div>
                        <div className="section-title text-center">
                            <span>İletişim</span>
                            <h2>Bize Ulaşın</h2>
                        </div>
                        <div className="tp-contact-form-area">
                            <ContactForm/>
                        </div>
                    </div>                
                </div>
            </div> 
            <section className="tp-contact-map-section">
                <div className="tp-contact-map">
                    <iframe 
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3111.4334554806546!2d35.36619657654542!3d38.75376117175506!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x152b054a8345b7e5%3A0xc0a1b1b7372a4152!2sAlza%20Makine%20Sanayi%20Ve%20Ticaret%20Ltd.%20%C5%9Eti.!5e0!3m2!1str!2str!4v1739186821890!5m2!1str!2str"
                        width="600"
                        height="450"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    ></iframe>
                </div>
            </section>
        </section>
     )
        
}

export default ContactSection;
